import order from "./modules/order";

export default {
    order,
}